import PropTypes from 'prop-types';

import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';

const DocumentPreview = ({ blobUrl }) => {
  return (
    <div className="w-100">
      <h4 className="midlightgrey f-small fw5 ttu mt15">Preview</h4>
      <DocViewer
        style={{ minHeight: 500 }}
        pluginRenderers={DocViewerRenderers}
        documents={[
          {
            uri: blobUrl,
          },
        ]}
      />
    </div>
  );
};

DocumentPreview.propTypes = {
  blobUrl: PropTypes.string,
};

export default DocumentPreview;
